import { render } from "./message.vue?vue&type=template&id=70676d00"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\zhuxu\\source\\repos\\innosource\\site\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__